import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "seo";
var seoService = {
    linkKontrol(link) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                link: link,
                methodName: "linkKontrol"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    seoTanimlama(tipi,link,seobaslik,seoIcerik,kategori) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                tipi: tipi,
                link: link,
                seobaslik: seobaslik,
                seoIcerik: seoIcerik,
                kategori: kategori,
                methodName: "linkKontrol"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default seoService

